import {
    GET_PROBLEM_INIT,
    GET_PROBLEM_SUCCESS,
    GET_PROBLEM_ERROR,
    SET_PROBLEM_REQUEST_ACCEPT_INIT,
    SET_PROBLEM_REQUEST_ACCEPT_SUCCESS,
    SET_PROBLEM_REQUEST_ACCEPT_ERROR,
    SET_PROBLEM_REQUEST_REJECT_INIT,
    SET_PROBLEM_REQUEST_REJECT_SUCCESS,
    SET_PROBLEM_REQUEST_REJECT_ERROR,
    SET_PROBLEM_REQUEST_REJECT_WITH_INVOICE_INIT,
    SET_PROBLEM_REQUEST_REJECT_WITH_INVOICE_SUCCESS,
    SET_PROBLEM_REQUEST_REJECT_WITH_INVOICE_ERROR,

    GET_PROBLEM_ADVISOR_INIT,
    GET_PROBLEM_ADVISOR_SUCCESS,
    GET_PROBLEM_ADVISOR_ERROR,
    SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_INIT,
    SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_SUCCESS,
    SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_ERROR,
    SET_PROBLEM_ADVISOR_REQUEST_REJECT_INIT,
    SET_PROBLEM_ADVISOR_REQUEST_REJECT_SUCCESS,
    SET_PROBLEM_ADVISOR_REQUEST_REJECT_ERROR,
    SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_WITH_INVOICE_INIT,
    SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_WITH_INVOICE_SUCCESS,
    SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_WITH_INVOICE_ERROR,
} from '../constants/ProblemConstants.js';

export const getProblemInit = () => ({
    type: GET_PROBLEM_INIT,
});

export const getProblemSuccess = (data) => ({
    type: GET_PROBLEM_SUCCESS,
    data
});

export const getProblemError = (error) => ({
    type: GET_PROBLEM_ERROR,
    error
});

export const setProblemRequestAcceptActionInit = (data) => ({
    type: SET_PROBLEM_REQUEST_ACCEPT_INIT,
    data,
  });
  
  export const setProblemRequestAcceptActionSuccess = (data) => ({
    type: SET_PROBLEM_REQUEST_ACCEPT_SUCCESS,
    data,
  });
  
  export const setProblemRequestAcceptActionError = (error) => ({
    type: SET_PROBLEM_REQUEST_ACCEPT_ERROR,
    error,
  });

  export const setProblemRequestRejectActionInit = (data) => ({
    type: SET_PROBLEM_REQUEST_REJECT_INIT,
    data,
  });
  
  export const setProblemRequestRejectActionSuccess = (data) => ({
    type: SET_PROBLEM_REQUEST_REJECT_SUCCESS,
    data,
  });
  
  export const setProblemRequestRejectActionError = (error) => ({
    type: SET_PROBLEM_REQUEST_REJECT_ERROR,
    error,
  });

  export const setProblemRequestRejectWithInvoiceActionInit = (data) => ({
    type: SET_PROBLEM_REQUEST_REJECT_WITH_INVOICE_INIT,
    data,
  });
  
  export const setProblemRequestRejectWithInvoiceActionSuccess = (data) => ({
    type: SET_PROBLEM_REQUEST_REJECT_WITH_INVOICE_SUCCESS,
    data,
  });
  
  export const setProblemRequestRejectWithInvoiceActionError = (error) => ({
    type: SET_PROBLEM_REQUEST_REJECT_WITH_INVOICE_ERROR,
    error,
  });


  export const getProblemAdvisorInit = () => ({
    type: GET_PROBLEM_ADVISOR_INIT,
});

export const getProblemAdvisorSuccess = (data) => ({
    type: GET_PROBLEM_ADVISOR_SUCCESS,
    data
});

export const getProblemAdvisorError = (error) => ({
    type: GET_PROBLEM_ADVISOR_ERROR,
    error
});

export const setProblemAdvisorRequestAcceptActionInit = (data) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_INIT,
  data,
});

export const setProblemAdvisorRequestAcceptActionSuccess = (data) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_SUCCESS,
  data,
});

export const setProblemAdvisorRequestAcceptActionError = (error) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_ERROR,
  error,
});

export const setProblemAdvisorRequestRejectActionInit = (data) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_REJECT_INIT,
  data,
});

export const setProblemAdvisorRequestRejectActionSuccess = (data) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_REJECT_SUCCESS,
  data,
});

export const setProblemAdvisorRequestRejectActionError = (error) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_REJECT_ERROR,
  error,
});

export const setProblemAdvisorRequestAcceptWithInvoiceActionInit = (data) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_WITH_INVOICE_INIT,
  data,
});

export const setProblemAdvisorRequestAcceptWithInvoiceActionSuccess = (data) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_WITH_INVOICE_SUCCESS,
  data,
});

export const setProblemAdvisorRequestAcceptWithInvoiceActionError = (error) => ({
  type: SET_PROBLEM_ADVISOR_REQUEST_ACCEPT_WITH_INVOICE_ERROR,
  error,
});